import { Stack, SvgIcon, Typography } from "@mui/material";

import QubitLogo from "~/assets/img/QubitLogo.svg?react";

const AppNavbarLogo = () => {
  return (
    <Stack flexDirection="row" alignItems="center" gap={1.25}>
      <SvgIcon
        component={QubitLogo}
        viewBox="0 0 64 64"
        color="secondary"
        sx={{
          height: "32px",
          width: "32px",
          display: "block",
          margin: "auto"
        }}
      />
      <Typography
        variant="body1"
        color="text.primary"
        fontWeight={600}
        sx={{ display: { xs: "none", sm: "block" } }}
      >
        Qubit
      </Typography>
    </Stack>
  );
};

export default AppNavbarLogo;
